import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft, Play, Loader2, BookOpen } from 'lucide-react';
import { getPublicSeriesDetail } from '../services/cms';

const SeriesDetail = () => {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    setData(null); setError(false);
    getPublicSeriesDetail(slug).then(setData).catch(() => setError(true));
  }, [slug]);

  if (error) return (
    <div className="max-w-7xl mx-auto px-4 py-20 text-center"><p className="font-display text-xl mb-4">Série introuvable.</p><Link to="/series" className="text-primary font-800">Retour aux séries</Link></div>
  );
  if (!data) return <div className="py-20 flex justify-center"><Loader2 className="w-8 h-8 animate-spin text-primary" /></div>;

  const { serie, episodes } = data;

  return (
    <div>
      <div className="relative h-64 sm:h-80 overflow-hidden">
        <img src={serie.couverture_url} alt={serie.titre} className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/40 to-black/20" />
        <div className="absolute inset-0 flex items-end">
          <div className="max-w-7xl mx-auto px-4 pb-8 w-full">
            <Link to="/series" className="inline-flex items-center gap-2 text-white/90 font-700 mb-4 hover:text-secondary transition-colors"><ArrowLeft className="w-4 h-4" /> Séries</Link>
            <h1 className="font-display font-700 text-3xl sm:text-5xl text-white">{serie.titre}</h1>
            {serie.auteur && <p className="text-white/80 font-700 mt-2">par {serie.auteur}</p>}
          </div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 py-10">
        <p className="text-foreground/80 text-lg mb-8">{serie.resume}</p>
        <h2 className="font-display font-700 text-2xl mb-5 flex items-center gap-2"><BookOpen className="w-6 h-6 text-primary" /> Épisodes</h2>
        {episodes.length === 0 ? (
          <p className="text-muted-foreground font-600">Aucun épisode publié pour le moment.</p>
        ) : (
          <div className="space-y-3">
            {episodes.map((ep, i) => (
              <Link key={ep.id} to={`/lire/${ep.slug}`}
                className="card-hover group flex items-center gap-4 bg-card border border-border rounded-2xl p-3 animate-float-up" style={{ animationDelay: `${i * 50}ms` }}>
                <div className="w-20 h-20 rounded-xl overflow-hidden shrink-0 bg-muted">
                  {ep.image_couverture_url ? <img src={ep.image_couverture_url} alt={ep.titre} loading="lazy" className="w-full h-full object-cover" /> : <div className="w-full h-full flex items-center justify-center font-display font-700 text-2xl text-primary">{ep.numero}</div>}
                </div>
                <div className="flex-1 min-w-0">
                  <span className="text-xs font-800 text-primary">Épisode {ep.numero}</span>
                  <h3 className="font-display font-600 text-lg leading-tight truncate group-hover:text-primary transition-colors">{ep.titre}</h3>
                  <p className="text-sm text-muted-foreground line-clamp-1">{ep.resume_court}</p>
                </div>
                <span className="w-11 h-11 rounded-full bg-primary text-white flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform"><Play className="w-5 h-5 fill-white ml-0.5" /></span>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SeriesDetail;
